export default __webpack_public_path__ + "static/media/pictogramCurrency40.54db04ba.svg";